
import { Document, Packer, Header, Footer, Paragraph, ImageRun, TextRun, TabStopType, TabStopPosition, HeadingLevel, PageBreak, PageNumber, AlignmentType } from 'docx'

// import { getDownloadURL } from '@/services/aws'
// import { isObject } from '@/services/validation'
import store from '@/store'

let sizeOf = require('buffer-image-size')


// const getFirstDocByType = ({ record, doctype }) => {
//   let location = record.getCurrentIterationCaseData()

//   return location.Docs[doctype] && Array.isArray(location.Docs[doctype])
//     ? location.Docs[doctype][0]
//     : null
// }

// const getImageFromAWSOld = async ({ Doc, doctype, record, token }) => {
//   let img = Doc

//   if (!img) {
//     img = getFirstDocByType({ record, doctype })
//   }

//   if (! isObject(img)) {
//     img = {
//       id: img,
//       ext: null,
//     }
//   }

//   // TODO: CBAPI - FILES
//   img.link = await getDownloadURL({
//     token,
//     ref: record.ref,
//     uuid: record.uuid,
//     casefull: record.case_ref,

//     index: img.id,
//     doctype,
//     ext: img.ext || null,
//   })

//   let file = await fetch(img.link.downloadURL)
//   let arrayBuffer = await file.arrayBuffer()
//   img.buffer = Buffer.from(arrayBuffer)

//   let size = sizeOf(img.buffer)
//   let sizeFactor = size.width > 600 ? 600 / size.width : 1

//   img.calcSize = {
//     width: size.width * sizeFactor,
//     height: size.height * sizeFactor,
//   }

//   return img
// }

const getImageFromAWS = async function({ store, uuid }) {
  try {
    // Assume the file is always available... 
    // The API will be quick to throw an error if we're wrong
    let url = await store.dispatch('files/getFileLinkByUuid', { uuid })

    const img = {
      link: url
    }
    let file = await fetch(url)
    let arrayBuffer = await file.arrayBuffer()
    img.buffer = Buffer.from(arrayBuffer)

    let size = sizeOf(img.buffer)
    let sizeFactor = size.width > 600 ? 600 / size.width : 1

    img.calcSize = {
      width: size.width * sizeFactor,
      height: size.height * sizeFactor,
    }

    return img

  } catch(e) {
    console.log(e)
    return null
  }
}


export const generateDoc = async ({ record, connectedRequests }) => { // token
  // const contractor = store.getters['tenant/getContractorByUuid']({ uuid: record.CurrentLocation.Contractor })
  const  relatedRequests = connectedRequests.filter(Boolean)

  const Contractor = store.getters['stakeholders/getStakeholderBySlug']({ 
    slug: record.getStakeholderSlugByCategory({ category: 'contractor' }) 
  })
  const ChargePointOperator = store.getters['stakeholders/getStakeholderBySlug']({ 
    slug: record.getStakeholderSlugByCategory({ category: 'cpo' }) 
  })
  const GridOperator = store.getters['stakeholders/getStakeholderBySlug']({ 
    slug: record.getStakeholderSlugByCategory({ category: 'gridoperator' }) 
  })

  let casefull = record.getCaseRef()
  let locationUuid = record.getConnectedLocationUuid()
  let location = store.getters['chargingpoints/getChargingPointByUUID']({
    uuid: locationUuid
  })
  let caseData = record.getCurrentIterationCaseData()
  let coordinates = 'onbekend'

  if (location.hasCoordinates()) {
    coordinates = location.getCoordinates()
    coordinates = `${coordinates.lat}, ${coordinates.lng}` // `Lat ${coordinates.lat} N, Lng ${coordinates.lng} E`
  }

  let topviewDoc = false
  let sideviewDoc = false

  if (record.hasFileOfCategory({ category: 'topview' })) {
    try {
      topviewDoc = await getImageFromAWS({
        store,
        uuid: record.getFileDataByCategory({ category: 'topview' })?.[0]?.uuid
      })
    } catch (e) {
      console.log(e)
      // applied to allow generation of docs to continue in case there is something wrong with an image
    }
  }

  if (record.hasFileOfCategory({ category: 'sideview' })) {
    try {
      sideviewDoc = await getImageFromAWS({
        store,
        uuid: record.getFileDataByCategory({ category: 'sideview' })?.[0]?.uuid
      })
    } catch (e) {
      console.log(e)
      // applied to allow generation of docs to continue in case there is something wrong with an image
    }
  }


  /**
   * DOC content blocks
   */

  let children = [
    // new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: 'Locatie',
          bold: true,
        }),
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: 'Realisatie adres: ',
        }),
        new TextRun({
          text: `\t${location.getFormattedAddress()}`,
        }),
      ],
      tabStops: [
        {
            type: TabStopType.LEFT,
            position: 2500,
        },
      ],
      // spacing: {
      //   after: 100
      // }
    }),
    new Paragraph({
      children: [
        new TextRun('Coordinaten (Lat, Lng): '),
        new TextRun({
          text: `\t${coordinates}`,
          // bold: true
        }),
      ],
      tabStops: [
        {
          type: TabStopType.LEFT,
          position: 2500,
        },
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: 'Bovenaanzicht',
          bold: true,
        }),
      ],
    }),
  ]

  if (topviewDoc) {
    children.push(
        // new Paragraph(''),
      new Paragraph({
        children: [
          new ImageRun({
            data: topviewDoc.buffer,
            transformation: {
              width: topviewDoc.calcSize.width,
              height: topviewDoc.calcSize.height,
            },
          }),
        ],
      }),
    )
  } else {
    children.push(
      // new Paragraph(''),
      new Paragraph({
        children: [
          new TextRun({
            text: 'Er is geen bovenaanzicht beschikbaar',
          }),
        ],
      }),
    )
  }


  children = children.concat([
    new Paragraph(''),
    // new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: 'Zijaanzicht',
          bold: true,
        }),
      ],
    }),
  ])

  if (sideviewDoc) {
    children.push(
        // new Paragraph(''),
      new Paragraph({
        children: [
          new ImageRun({
            data: sideviewDoc.buffer,
            transformation: {
              width: sideviewDoc.calcSize.width,
              height: sideviewDoc.calcSize.height,
            },
          }),
          new PageBreak(),
        ],
      }),
    )
  } else {
    children.push(
      // new Paragraph(''),
      new Paragraph({
        children: [
          new TextRun({
            text: 'Er is geen zijaanzicht beschikbaar',
          }),
          new PageBreak(),
        ],
      }),
    )
  }


  /********************************************************************
   * PAGE 2
   */
  children = children.concat([
    new Paragraph({
      children: [
        new TextRun({
          text: 'Inrichting',
          bold: true,
        }),
      ],
    }),
    new Paragraph(''),
  ])

  // Exclude 'Laadsituatie' for PNC tenant
  if (record.tenant !== 'park-n-charge') {
    children = children.concat([
      new Paragraph({
        children: [
          new TextRun({
            text: 'Laadsituatie: ',
          }),
          new TextRun({
            text: `\t${caseData?.ParkingSpots?.Type === 'hub' ? 'laadcluster' : 'laadpaal' }`,
          }),
        ],
        tabStops: [
          {
              type: TabStopType.LEFT,
              position: 2500,
          },
        ],
      }),
    ])
  }

  children = children.concat([
    new Paragraph({
      children: [
        new TextRun({
          text: 'Aantal laadpalen: ',
        }),
        new TextRun({
          text: `\t${caseData?.ParkingSpots?.NumberOfChargingStations}`,
        }),
      ],
      tabStops: [
        {
            type: TabStopType.LEFT,
            position: 2500,
        },
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: 'Aantal parkeerplaatsen: ',
        }),
        new TextRun({
          text: `\t${caseData?.ParkingSpots?.NumberOfParkingSpots}`,
        }),
      ],
      tabStops: [
        {
            type: TabStopType.LEFT,
            position: 2500,
        },
      ],
    }),
  ])

  if (caseData.ParkingSpots.Identifiers.length) {
    children = children.concat([
      new Paragraph({
        children: [
          new TextRun({
            text: 'Parkeerplaatsen: ',
          }),
          new TextRun({
            text: `\t${caseData?.ParkingSpots?.Identifiers?.map(item => item.Identifier).join(', ')}`,
          }),
        ],
        tabStops: [
          {
              type: TabStopType.LEFT,
              position: 2500,
          },
        ],
      }),
    ])
  }

  /**
   * FINANCIAL UNIT CONDITIONAL
   */
  if (record.tenant === 'park-n-charge') {
    children = children.concat([
      new Paragraph(''),
      new Paragraph({
        children: [
          new TextRun({
            text: 'Financiële unit: ',
          }),
          new TextRun({
            text: `\t${caseData.FinUnit}`,
          }),
        ],
        tabStops: [
          {
              type: TabStopType.LEFT,
              position: 2500,
          },
        ],
      }),
    ])
  }

  children = children.concat([
    /**
     * Remarks
     */
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: 'Toelichting bij het locatievoorstel:',
          bold: true,
        }),
      ],
    }),
  ])

  if (record.tenant !== 'park-n-charge') {
    children.push(new Paragraph(''))
  }

  children = children.concat([
    new Paragraph(caseData.Remarks || ''),

    /**
     * Remarks
     */
     new Paragraph(''),
     new Paragraph({
       children: [
         new TextRun({
           text: 'Locatie voorbereiding',
           bold: true,
         }),
       ],
     }),
     new Paragraph(''),
     new Paragraph({
      children: [
        new TextRun({
          text: 'Netbeheerder: ',
        }),
        new TextRun({
          text: `\t${GridOperator?.name || ''}`,
        }),
      ],
      tabStops: [
        {
            type: TabStopType.LEFT,
            position: 2500,
        },
      ],
    }),

    new Paragraph({
      children: [
        new TextRun({
          text: 'Werkzaamheden: ',
        }),
        new TextRun({
          text: `\t${caseData?.LocationPreparation?.RequiresLocationPreparation?.join(', ')}`,
        }),
      ],
      tabStops: [
        {
            type: TabStopType.LEFT,
            position: 2500,
        },
      ],
    }),

    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: 'Overige werkzaamheden: ',
        }),
      ],
      tabStops: [
        {
            type: TabStopType.LEFT,
            position: 2500,
        },
      ],
    }),
    new Paragraph(caseData?.LocationPreparation?.OtherReason || '-'),

    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: 'Aannemer',
          bold: true,
        }),
      ],
      tabStops: [
        {
            type: TabStopType.LEFT,
            position: 2500,
        },
      ],
    }),
    new Paragraph(Contractor?.name || '-'),

    new Paragraph(''),

    new Paragraph({
      children: [
        new TextRun({
          text: 'Uitvoering laadpaal:',
          bold: true,
        }),
      ],
      tabStops: [
        {
          type: TabStopType.LEFT,
          position: 2500,
        },
      ],
    }),
    new Paragraph(caseData?.CPOAdvice?.ChargingStationVersion || '-'),
    new Paragraph(''),

    new Paragraph({
      children: [
        new TextRun({
          text: record.tenant === 'park-n-charge'
            ? 'Toelichting op de uitvoering: '
            : 'Door gemeente uit te voeren: ',
          bold: true,
        }),
      ],
      tabStops: [
        {
            type: TabStopType.LEFT,
            position: 2500,
        },
      ],
    }),
    new Paragraph(caseData?.CPOAdvice?.AdditionalCostDescription || '-'),
    new Paragraph(''),

    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: 'Type realisatieproces',
          bold: true,
        }),
      ],
      tabStops: [
        {
            type: TabStopType.LEFT,
            position: 2500,
        },
      ],
    }),
    new Paragraph(record.getProcessTypeLabel() || '-'),
    new Paragraph(''),

    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun({
          text: 'Tags',
          bold: true,
        }),
      ],
      tabStops: [
        {
            type: TabStopType.LEFT,
            position: 2500,
        },
      ],
    }),
    new Paragraph(record.getTagLabels().join(', ') || '-'),
    new Paragraph(''),
  ])


  /**
   * DOC MAIN Spec
   */
  const docSpec = {
    sections: [
      {
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                text: `Startdocument - ${location.getShortAddress()}`,
                heading: HeadingLevel.HEADING_1,
              }),
              new Paragraph({
                text: `Referentie: ${casefull}`,
                bold: true,
              }),
            ],
            tabStops: [
              {
                  type: TabStopType.RIGHT,
                  position: TabStopPosition.MAX,
              },
            ],
          }),
        },
        footers: {
          default: new Footer({
            children: [
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun(`Realisatie adres: ${location.getFormattedAddress()}`),
                  new TextRun({
                    children: [' / CPO: ', ChargePointOperator?.name || ''],
                  }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    children: ['Pagina ', PageNumber.CURRENT],
                  }),
                  new TextRun({
                    children: [' / ', PageNumber.TOTAL_PAGES],
                  }),
                ],
              }),
            ],
          }),
        },

        children,
      },
    ],
  }

  if (relatedRequests.length !== 0) {
    docSpec.sections[0].children.push(
      new Paragraph({
        children: [
          new TextRun({
            text: 'Verbonden aanvragen',
            bold: true,
          }),
        ],
      }),
    )
    docSpec.sections[0].children.push(
      new Paragraph(''),
    )
  }

  relatedRequests.forEach(request => {
    docSpec.sections[0].children.push(
      new Paragraph({
        text: `${request.case_ref}: ${request.summary.address}`,
        bullet: {
          level: 0,
        },
      }),
    )
  })

  const doc = new Document(docSpec)

  return await Packer.toBlob(doc)
}
